/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Base editor form container
 */
import {
  AfterContentInit,
  Component,
  DoCheck,
  ElementRef,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Location } from '@angular/common';

import {
  Observable,
  observableCombineLatest,
  observableDefer,
  observableEMPTY,
  observableFrom,
  observableMerge,
  observableOf,
  observableTimer,
  rx,
  Subscription,
} from '@shared/rx';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {
  castArray,
  chain,
  compact,
  concat,
  each,
  filter,
  find,
  findIndex,
  flatten,
  forEach,
  get,
  has,
  head,
  includes,
  invoke,
  isEmpty,
  isFunction,
  isNil,
  isUndefined,
  map,
  merge,
  orderBy,
  reduce,
  set,
  split,
  startCase,
  startsWith,
  toLower,
  uniq,
  pick,
  isEqual,
  uniqBy,
  isArray,
  isBoolean,
} from 'lodash';
import { APIActions, ToolsActions, UiActions } from '@store/actions';
import {
  createFormDefinitionsFromSchema,
  createFormGroupFromSchema,
  ICommonFormAction,
  IFormAction,
  IFormGroupRules,
} from '@components/form/services';
import {
  BaseFormService,
  CompanyUtilService,
  EntityServiceProvider,
  PermissionService,
  STATE_KEYS,
  StateService,
  UtilityServiceProvider,
  ValidationService,
  WindowWrapperService,
  XprtDataService,
} from '@shared/services';

import {
  ACTION_PLACE,
  AnyObject,
  EDITOR_MODE,
  ENTITY_TYPES,
  FieldsToKeepAfterUpdateType,
  IBaseEntityType,
  IBeforePageLoadPopupOptions,
  IChangedFieldsDefinition,
  ICheckerMap,
  ICompanyUserType,
  IDeleteConfirmationMessageOptionsList,
  IDocumentErrorMessage,
  IDocumentInfoMessage,
  IDocumentOperationOptions,
  IEntityConfig,
  IFieldPreferences,
  IFormGroupPreferences,
  IFormRules,
  IKeyValueAny,
  IModalDialogOptions,
  IModalDialogResult,
  IOpenRouteOptions,
  IOperationHistory,
  IPageJumpRouteState,
  ISideBarItem,
  IStatusHistory,
  IWidgetEvent,
  ObjectId,
  SchemaNode,
  ToolbarButtonDefinition,
  TRANSFER_PRINT_TYPE,
  USER_ACCESS,
  XUX_FORM_ACTIONS,
  WIDGET_COMPONENT,
  SupportedAppCodes,
  CustomRedirect,
  CustomRedirectFun,
  CustomRedirectOptions,
  IDuplicateOption,
  XUX_GRID_ACTIONS,
} from '@shared/types';
import { IComponentCanDeactivate } from '@shared/helpers/edit-guard/edit-guard.helper';
import {
  buildFormGetter,
  buildFormReadyObsGetter,
  generateObjectId,
  getCheckerAndCheckerMap,
  isTimeoutStatusCode,
  removeNullPropertiesFromObject,
} from '@shared/utils';
import {
  ENTITY_ID_PATH,
  ERROR_MESSAGE_DEBOUNCE,
  FieldsToKeepInDocumentAfterUpdateEnum,
  NO_THEME_CLASS,
  XUX_FORM_THEME_CLASS,
} from '@config/index';
import { API_ERROR_CODES, ERROR_PAGE_TEMPLATES } from '@app/text-content';
import { NOT_PERMITTED_ERROR_PAGE_TEMPLATE } from '@text-content/error-page-templates/error-page-templates-content';
import { XVIError } from '@shared/models';
import { EDITOR_MESSAGES } from '@shared/constants';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { BTN_CANCEL, BTN_DONE, BTN_YES } from '@text-content/button-templates';
import {
  COLLAPSE_ANIMATION_DURATION_MS,
  TIME_FORMATS,
} from '@config/global-constants';
import { IFieldValueChangesOptions } from '@components/form/services/schema-form/schema-form-interfaces';
import { getSingularEntityName } from '@shared/configs';
import {
  DOCUMENT_PATH,
  ENTITY_MODULE,
} from '@app/shared/constants/document-paths';
import { COMMON_STATUS } from '@app/shared/types/enums/common-status.enum';
import { lazyInject } from '../../decorators';
import { PdfBaseService } from '@app/shared/common/make-pdf';
import { pdfModalDefinition } from '@app/shared/common/make-pdf/modal.definition';
import { select } from '@angular-redux/store';
import { StaffDataService } from '@app/shared/services/staff-data';
import { IPopupOptions } from '@app/components/popup/types/popup-options.types';
import {
  DetailDrawerFormData,
  AdditionBuildOptions,
  DetailDrawerFormComponent,
} from '@app/components/popup';
import { IStaffUserInfo } from '@app/shared/services/staff-data/staff-data.types';
import { XVII18nService } from '@app/i18n/services/xvi-translate.service';
import { I18n } from '@app/i18n/strings-keys';
import {
  ICommonFormConfig,
  IFormExpanded,
  MainForm,
  MainOrSubFormGroups,
  MainOrSubFormKey,
} from '@app/components/form/common-form/common-form.types';
import { XuxXVISchemaFormComponent } from '@app/components/xux/xux-schema-form/xux-schema-form.component';
import { GridApi } from 'ag-grid-community';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-base-edit-container',
  templateUrl: './editor.base.container.html',
})
export class BaseEditorContainerComponent
  implements
    OnInit,
    OnDestroy,
    IComponentCanDeactivate,
    AfterContentInit,
    DoCheck
{
  @ViewChild('xuxSchemaForm', { static: false })
  public xuxSchemaForm: XuxXVISchemaFormComponent;

  public get isXuxThemeActivated(): boolean {
    return this.xuxTheme;
  }
  public showForm: boolean = true;
  // define the container whether need organization the  get_updated_items to api parameters
  public getUpdatedItemsDefaultValue: boolean = false;

  public bannerText: string = '';
  public expandSidebar: boolean = true;
  public showSidebarCollapsedBtn: boolean = false;
  public showAuditTrailButton: boolean = false;

  public formReady$: BehaviorSubject<Record<MainForm | string, boolean>> =
    new BehaviorSubject<Record<MainForm | string, boolean>>({ main: false });

  public enableRightExpand$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public rightExpanded$: BehaviorSubject<IFormExpanded> =
    new BehaviorSubject<IFormExpanded>({
      key: '',
      expanded: false,
    });

  public isFormExpandedObs(formKey: string): Observable<boolean> {
    return this.rightExpanded$.pipe(
      rx.map((expandedObj) =>
        !isEmpty(formKey) && isEqual(expandedObj.key, formKey)
          ? expandedObj.expanded
          : false,
      ),
    );
  }

  protected _rightFormsConfig: ICommonFormConfig[] = [];
  public set rightFormsConfig(value: ICommonFormConfig | ICommonFormConfig[]) {
    this._rightFormsConfig = isArray(value) ? value : [value];
  }
  public get rightFormsConfig(): ICommonFormConfig[] {
    return this._rightFormsConfig;
  }

  public showDetailDrawerPopup: boolean = false;
  public detailDrawerPopupOptions: IPopupOptions = null;

  public dynamicHeaderButtons: ToolbarButtonDefinition[] = [];

  /**
   * configure this to decide which fields need to be carry when jump to create new
   */
  protected createWithDataCarryFields: string[] = [];

  protected detailDrawerPopupDocument: object = {};

  public get canSave(): boolean {
    return this.isEditMode() ? this.canManage : this.canAdd;
  }

  public get canEdit(): boolean {
    return (
      (this.canManage && this.isEditMode()) || (this.canAdd && this.isNewMode())
    );
  }

  protected set formRules$(formRules$: Observable<IFormRules>) {
    this._formRules$ = formRules$;
    if (this.formRulesSubscription) {
      this.formRulesSubscription.unsubscribe();
    }

    this.formRulesSubscription = observableCombineLatest([
      this.schema$,
      formRules$.pipe(rx.filter((rules: IFormRules) => !!rules)),
      observableFrom(Promise.all(this.resolvers)),
    ]).subscribe(
      async ([schema, rawFormRules]: [SchemaNode, IFormRules, any[]]) => {
        const translatedSchema = this.i18nService.translateTextInSchema(schema);

        const { confirmed, value } =
          await this.showBeforePageLoadPopup(translatedSchema);
        let mappedRawFormRules = this.formRulesMapper(rawFormRules);

        if (!confirmed) return;
        if (value) {
          mappedRawFormRules = this.beforePageLoadPopupFormRulesMapper<
            typeof value
          >(rawFormRules, value);
        }

        const formRules = this.mergeFormRules(mappedRawFormRules);

        const updatedFormRules = { ...formRules };
        const translatedFormRules = this.i18nService.translateTextInFormRules(
          updatedFormRules,
          schema,
        );

        this.bannerText = updatedFormRules.bannerText;

        // form should be created only once, to keep valueChanges subscriptions workable.
        // Validators defined in form rules can not be redefined.
        // However, dynamic validators may be operated via form field methods
        if (!this.form) {
          this.initForm(translatedSchema, translatedFormRules);
          this.subscriptions.push(
            this.route.queryParams.subscribe(({ group }) =>
              this.setActiveGroup(group),
            ),
          );
        }

        const groups: IFormGroupPreferences[] = createFormDefinitionsFromSchema(
          {
            schema: translatedSchema,
            rules: translatedFormRules,
            form: this.form,
            eventBus$: this._widgetsEventBus$.asObservable(),
            fieldsToSetDisable: this.getFieldsToSetDisable(translatedFormRules),
            i18nService: this.i18nService,
            keepReference: true,
          },
        );
        const shouldDisableControl: boolean = !this.canSave;

        if (shouldDisableControl) {
          flatten(map(groups, 'fields')).forEach((field: IFieldPreferences) => {
            const suppressNoPermissionsDisable = get(
              field,
              'suppressNoPermissionsDisable',
              false,
            );
            set(
              field,
              'disabledObs',
              observableOf(!suppressNoPermissionsDisable),
            );
          });
        }

        this.groups = groups;
      },
    );
  }

  protected get formRules$(): Observable<IFormRules> {
    return this._formRules$;
  }

  public showItemEditedMark$: BehaviorSubject<boolean> = new BehaviorSubject(
    false,
  );

  public I18n = I18n;

  public staticTextContent = {
    edited: I18n.Common.Edited,
    Save: I18n.Common.Save,
    ToggleDropdown: I18n.Common.ToggleDropdown,
    SaveAndClose: I18n.Common.SaveAndClose,
    SaveAndNew: I18n.Common.SaveAndNew,
    Duplicate: I18n.Common.Duplicate,
    Cancel: I18n.Common.Cancel,
    Delete: I18n.Common.Delete,
    AuditTrail: I18n.EntityNames.AuditTrail,
    ExportCSV: I18n.Common.ExportCSV,
    Print: I18n.Common.Print,
  };

  @ViewChild('childButtonsList', { static: false, read: ElementRef })
  public childButtonsList: ElementRef;
  @ViewChild('drawerContainer')
  public drawerContainer: DetailDrawerFormComponent;

  @select(STATE_KEYS.UI_EDITOR_OPTIONS_STATE)
  public routeState$: Observable<IPageJumpRouteState>;

  @lazyInject(XVII18nService)
  public i18nService: XVII18nService;
  @lazyInject(ActivatedRoute) public route: ActivatedRoute;
  @lazyInject(Router) public readonly router: Router;
  @lazyInject(UiActions) public uiActions: UiActions;
  @lazyInject(ToolsActions) public toolActions: ToolsActions;
  @lazyInject(APIActions) public apiActions: APIActions;
  @lazyInject(StateService) public stateService: StateService;
  @lazyInject(ValidationService) public validationService: ValidationService;
  @lazyInject(EntityServiceProvider)
  public entityServiceProvider: EntityServiceProvider;
  @lazyInject(UtilityServiceProvider)
  public utilityServiceProvider: UtilityServiceProvider;
  @lazyInject(BaseFormService) public entityFormService: BaseFormService;
  @lazyInject(WindowWrapperService)
  public windowWrapperService: WindowWrapperService;
  @lazyInject(Location) public location: Location;
  @lazyInject(CompanyUtilService)
  public companyUtilsService: CompanyUtilService;
  @lazyInject(PdfBaseService) public pdfBaseService: PdfBaseService;
  @lazyInject(PermissionService) public permissionService: PermissionService;

  public entityIdPath: string = ENTITY_ID_PATH;
  public entityConfig: IEntityConfig = null;
  public mode: EDITOR_MODE = EDITOR_MODE.NEW;
  public canManage: boolean;
  public canAdd: boolean;
  public canRemove: boolean;

  public formRules: IFormRules;
  public newDocument: IBaseEntityType = {};
  public documentIds: ObjectId[] = [];

  public showCancelButton: boolean = true;
  public showSaveAndNewButton: boolean = true;
  public showSaveAndCloseButton: boolean = true;
  public showDeleteButton: boolean = true;
  public showSaveOptions: boolean = true;
  public showDuplicateButton: boolean = false;
  public showDiscardButton: boolean = true;
  public showDropdownOptions: boolean = true;
  public showExportButton: boolean = false;
  public showToggleExportButtons: boolean = false;
  public showToggleEmptyPrintButtons: boolean = false;
  public canViewAuditTrail: boolean;

  public canPrint: boolean = false;
  public canExportPDF: boolean = false;
  public isInModalDialog: boolean = false;
  public handelModalAfterSave: () => void;

  public disabledChildButtonDropdown: boolean = false;
  public isRequestPendingForEditor$: Observable<boolean>;

  public exportButtonText: string = I18n.Common.ExportPDF;
  public printEmptyColumnBtnText: string = I18n.Common.PrintWrittenSheet;
  public needBeforePageLoadPopup: boolean = true;
  // Expected to be redefined in descendants
  protected _formRules$: Observable<IFormRules>;
  protected _id: string;
  protected schema$: Observable<SchemaNode>;
  public errors: XVIError[];
  public error: XVIError;
  protected apiErrors$: Observable<any>;

  protected triggerSidebarDetailUpdate$: BehaviorSubject<IBaseEntityType> =
    new BehaviorSubject<IBaseEntityType>(null);

  protected changedFieldsDefinition: IChangedFieldsDefinition = {};
  // If we need to override default errors with custom override it to true
  // these are passed to the child form
  public form: FormGroup;
  public formPromise: Promise<FormGroup> = new Promise(
    (res: Function): void => {
      this.formResolver = res;
    },
  );

  public rightForms: Record<string, FormGroup> = {};
  public rightFormApis: Record<
    string,
    {
      gridApi: GridApi;
    }
  > = {};

  public documentPromise: Promise<object> = new Promise(
    (res: Function): void => {
      this.documentResolver = res;
    },
  );
  public groups: IFormGroupPreferences[];
  public currentDocument$: Observable<any>;
  public document: any;
  // document value that form was initially loaded (this property should not be mutated under any circumstances)
  public initialDocument: IBaseEntityType;
  protected formRulesSubscription: Subscription;
  public title: string = '';
  public documentResolver: Function;
  public resolvers: Promise<any>[] = [this.documentPromise];
  public entityType: ENTITY_TYPES;
  /**
   * use this to redirect page
   */
  public redirectEntityType: ENTITY_TYPES;

  // This subscriptions array re-filled after Save button click
  protected subscriptions: Subscription[] = [];
  // This subscriptions array EXIST and doesn't unsubscribe
  protected cleanedOnDestroySubscriptions: Subscription[] = [];
  protected fieldToKeepInDocumentAfterUpdateDefaultValue: FieldsToKeepAfterUpdateType =
    {
      [FieldsToKeepInDocumentAfterUpdateEnum.ENTITY_ID]: generateObjectId(),
    };

  // This fields will keep in doc and will provide to doc from original after update
  protected fieldsToKeepInDocumentAfterUpdate: FieldsToKeepInDocumentAfterUpdateEnum[] =
    [
      FieldsToKeepInDocumentAfterUpdateEnum.ENTITY_ID,
      FieldsToKeepInDocumentAfterUpdateEnum._ID,
    ];

  public isDeletedDocument: boolean = true;
  public isDeleteViewMode: boolean = false;
  public isHideSideBar: boolean = false;
  // xux related properties
  protected xuxTheme: boolean = false;
  public xuxSingleGroupForm: boolean = false;
  public entityTitle: string;
  public groupIndexControl: FormControl = new FormControl(0);

  public userProvideRouteSnapshot: ActivatedRouteSnapshot;

  public documentSidebarDetails: Partial<IBaseEntityType>;

  public saveOperationId: ObjectId;

  protected infoMessageData$: Observable<
    (IDocumentInfoMessage | IDocumentErrorMessage)[]
  >;

  protected formResolver: Function;

  protected isPageLeft: boolean = false;
  public isDuplicateMode: boolean = false;
  public duplicateOption: IDuplicateOption;

  protected topSaveButtonDefinition: ToolbarButtonDefinition = {
    caption: I18n.Common.Save,
    class: 'btn btn-default btn-primary',
    click: this.saveButtonClickHandler.bind(this),
    value: 'edit-xux-btn-save',
    disabled: (): boolean => this.getSaveDisabledDefaultCondition(),
    hidden: (): boolean => this.isDeletedDocument,
  };

  protected duplicateButtonDefinition: ToolbarButtonDefinition = {
    caption: I18n.Common.Duplicate,
    value: 'edit-xux-btn-duplicate',
    click: this.duplicateBtnClick.bind(this),
    hidden: (): boolean =>
      this.isNewMode() ||
      !this.showDuplicateButton ||
      !this.canAdd ||
      !this.form?.valid,
  };

  protected discardButtonDefinition: ToolbarButtonDefinition = {
    caption: I18n.Common.Discard,
    value: 'edit-xux-btn-discard',
    click: this.cancelBtnClick.bind(this),
    hidden: (): boolean => !this.showDiscardButton || !this.canEdit,
  };

  protected saveAndNewButtonDefinition: ToolbarButtonDefinition = {
    caption: I18n.Common.SaveAndNew,
    value: 'edit-xux-btn-save-and-new',
    click: this.saveAndNewButtonClickHandler.bind(this),
    hidden: (): boolean =>
      this.isInModalDialog ||
      !this.canAdd ||
      !this.canManage ||
      this.getSaveDisabledDefaultCondition(),
  };

  protected submitAndNewButtonDefinition: ToolbarButtonDefinition = {
    caption: I18n.Common.SubmitAndNew,
    value: 'edit-xux-btn-submit-and-new',
    click: this.submitAndNewButtonClickHandler.bind(this),
    hidden: (): boolean =>
      !this.form?.valid ||
      this.isInModalDialog ||
      !this.canAdd ||
      !this.canManage,
  };

  protected buttonDisableCheckerMap: ICheckerMap;
  protected buttonHiddenCheckerMap: ICheckerMap;

  protected get routerSnapshot(): ActivatedRouteSnapshot {
    return this.userProvideRouteSnapshot ?? this.route?.snapshot;
  }

  protected get routerEntityConfig(): IEntityConfig {
    return (
      this.userProvideRouteSnapshot?.data ??
      get(this, 'route.snapshot.data', null)
    );
  }

  public pageTopButtons$: BehaviorSubject<ToolbarButtonDefinition[]> =
    new BehaviorSubject([this.topSaveButtonDefinition]);

  public pageTopDropdownButtons$: BehaviorSubject<ToolbarButtonDefinition[]> =
    new BehaviorSubject([
      this.duplicateButtonDefinition,
      this.discardButtonDefinition,
    ]);

  /** Notice: keep in private and use {@link emitWidgetEvent} method to dispatch events */
  private _widgetsEventBus$: Subject<IWidgetEvent> =
    new Subject<IWidgetEvent>();

  private isFormBuilding: boolean;

  public constructor(public injector: Injector) {
    this.initBasicEntityProperty();
    this.duplicateOption = this.stateService.getByPath(
      STATE_KEYS.UI_EDITOR_OPTIONS_DUPLICATE,
    );
    this.isDuplicateMode = get(this.duplicateOption, 'isDuplicateMode', false);
  }

  public disabledFunc = (): boolean => {
    return !this.canEdit;
  };

  public initBasicEntityProperty(
    userProvideRouteSnapshot?: ActivatedRouteSnapshot,
  ): void {
    this.userProvideRouteSnapshot = userProvideRouteSnapshot;
    this.entityConfig = this.routerEntityConfig;

    if (isEmpty(this.entityConfig)) {
      return;
    }

    this.showDuplicateButton = this.getShowDuplicateParam();

    this.isInModalDialog = get(this.entityConfig, 'isInModalDialog', false);
    this.isHideSideBar = get(this.entityConfig, 'isHideSideBar', false);
    this.handelModalAfterSave = get(
      this.entityConfig,
      'handelModalAfterSave',
      null,
    );

    this.expandSidebar = get(this.entityConfig, 'expandSidebar', true);
    this.showSidebarCollapsedBtn = get(
      this.entityConfig,
      'showSidebarCollapsedBtn',
      false,
    );

    this.enableRightExpand$ = this.entityFormService.enableRightExpand$;

    this.entityType = this.entityConfig.ENTITY_TYPE;
    this.redirectEntityType = get(
      this.entityConfig,
      'REDIRECT_ENTITY_TYPE',
      this.entityType,
    );

    this.entityTitle = this.getEntityTitle();

    this.showDeleteButton = get(
      this.entityConfig,
      'buttons.remove',
      this.showDeleteButton,
    );

    const permissions = get(this.entityConfig, 'permissions', []);

    const service = this.entityServiceProvider.getService(this.entityType);
    const entityNameToCheckPermissions = get(
      service,
      'config.entityNameToCheckPermissions',
      this.entityType,
    );

    this.canManage = PermissionService.hasManagePermission(
      permissions,
      entityNameToCheckPermissions,
    );
    const canAddFormEntityConfig: IEntityConfig['editor']['canAdd'] = get(
      service,
      ['config', 'editor', 'canAdd'],
    );
    // add this for hawker session admin, admin's manage permission can add.
    if (
      isFunction(canAddFormEntityConfig) ||
      isBoolean(canAddFormEntityConfig)
    ) {
      this.canAdd = isFunction(canAddFormEntityConfig)
        ? canAddFormEntityConfig(
            entityNameToCheckPermissions,
            this.permissionService,
          )
        : canAddFormEntityConfig;
    } else {
      this.canAdd = PermissionService.hasAddPermission(
        permissions,
        entityNameToCheckPermissions,
      );
    }

    this.canAdd = this.canAdd && get(this.entityConfig, 'buttons.create', true);

    this.canRemove =
      PermissionService.hasDeletePermission(
        permissions,
        entityNameToCheckPermissions,
      ) && get(this.entityConfig, 'buttons.remove', this.showDeleteButton);
    this.canViewAuditTrail = PermissionService.hasViewPermission(
      permissions,
      ENTITY_TYPES.AUDIT_TRAIL,
      SupportedAppCodes.XDM,
    );
    this.isRequestPendingForEditor$ = this.getRequestPendingStatusForEditor();
  }

  protected getShowDuplicateParam(): boolean {
    return (
      (
        get(this.route.snapshot.queryParams, 'showDuplicate') ??
        this.showDuplicateButton
      )?.toString() === 'true'
    );
  }

  /**
   * get entity title
   * will try to get editor.entityTitle from route data
   * use getSingularEntityName(this.entityType) || startCase(this.entityType) as default
   */
  protected getEntityTitle(): string {
    const entityTitle = get(
      this.entityConfig,
      'editor.entityTitle',
      // default title
      getSingularEntityName(this.entityType) || startCase(this.entityType),
    );

    return this.i18nService.instant(entityTitle);
  }

  /**
   * combine page buttons & handle extra things(like check hidden/disable)
   *
   * @returns combined buttons change subscription
   */
  protected getPageButtonChangeSubscription(): Subscription {
    return observableCombineLatest([
      this.pageTopButtons$.pipe(rx.distinctUntilChanged()),
      this.pageTopDropdownButtons$.pipe(rx.distinctUntilChanged()),
    ])
      .pipe(
        rx.map(([topButtons, ...buttons]) => concat(topButtons, ...buttons)),
        rx.map((buttons) => filter(buttons, Boolean)),
        rx.filter((buttons) => !isEmpty(buttons)),
      )
      .subscribe(this.onPageButtonChanges.bind(this));
  }

  /**
   * handle page button connected property changes
   * will re-calc disable/hidden checker map for them
   *
   * @param buttons change buttons
   */
  protected onPageButtonChanges(buttons: ToolbarButtonDefinition[]): void {
    if (isEmpty(buttons)) {
      return;
    }
    this.buttonDisableCheckerMap = getCheckerAndCheckerMap(buttons, 'disabled');
    this.buttonHiddenCheckerMap = getCheckerAndCheckerMap(buttons, 'hidden');
  }

  /**
   * will trigger all button disable/hidden checker
   */
  public ngDoCheck(): void {
    this.buttonDisableCheckerMap?.checkers?.forEach((checker) => checker());
    this.buttonHiddenCheckerMap?.checkers?.forEach((checker) => checker());
  }

  public handleTopSectionBtnClick(btn): void {
    if (isFunction(btn.click)) {
      btn.click(this.document);
    }
  }

  /**
   * get is button disable from checker map
   *
   * @param button target button
   * @returns is disable observable
   */
  public isButtonDisabledObs(
    button: ToolbarButtonDefinition,
  ): Observable<boolean> {
    return this.buttonDisableCheckerMap?.map?.get(button) ?? observableOf(true);
  }

  /**
   * get is button hidden from checker map
   *
   * @param button target button
   * @returns is hidden observable
   */
  public isButtonHiddenObs(
    button: ToolbarButtonDefinition,
  ): Observable<boolean> {
    return this.buttonHiddenCheckerMap?.map?.get(button) ?? observableOf(true);
  }

  public setupEmitWidgetEvent(
    fn?: (widgetFieldPath: string, eventName: string, data: AnyObject) => void,
  ): void {
    setTimeout(() => this.entityFormService.setupEmitWidgetEvent(fn), 0);
  }

  public ngOnInit(): void {
    if (isEmpty(this.entityConfig)) {
      return;
    }
    this.title = this.getDefaultContainerTitle();
    this.setupEmitWidgetEvent(this.emitWidgetEvent.bind(this));
    this.document = Object.assign({}, this.newDocument);
    this.initStoreObservables();

    this.apiActions.ensureEntitySchemaLoaded(this.entityType);

    // fetch document on _id change
    this.acquireDocument();

    if (!this.entityConfig.editor?.notApplyTheme) {
      this.applyTheme();
    }

    this.infoMessageData$ = observableFrom(
      this.entityFormService.getInfoMessageInformation(),
    );
    this.saveOperationId = generateObjectId();

    this.childButtonsDisableHandler();
    this.saveInitialDocument();
    this.addEditedMarkSubscription();
    this.setDeleteViewMode();
    if (!this.isHideSideBar) {
      this.setDocumentSidebarDetails();
    }
  }

  public ngOnDestroy(): void {
    this.isPageLeft = true;
    this.mode = null;

    this.closeDrawer();

    if (this.isFormBuilding) {
      this.uiActions.formBuildingComplete();
    }
    this.unsubscribeAll();
    this.entityFormService.destroyFormDefinition();
    if (this._id) {
      this.apiActions.clearCurrentDocument(this.entityType);
    }

    if (!this.entityConfig.editor?.notApplyTheme && this.xuxTheme) {
      this.uiActions.showNavbar();
      this.uiActions.setUiTheme(NO_THEME_CLASS);
    }
    this.cleanedOnDestroySubscriptions.forEach((sub: Subscription) =>
      sub?.unsubscribe(),
    );
    this.uiActions.removeNotificationsOnPageLeave();
    this.uiActions.clearNonPatchedFormValue();
  }

  // here child ngOnInit already completed so we can subscribe and handle promises
  public ngAfterContentInit(): void {
    this.addResolversErrorHandler();

    // patch form value of document change
    // TODO: replace with document promise
    this.subscriptions.push(
      this.currentDocument$.subscribe((doc: IBaseEntityType) =>
        this.onDocumentChange(doc),
      ),
    );

    // if formRules$ observable has not been defined in child - use default static formRules.
    // formRules$ _setter_ updates formRules subscription so groups property is always depends
    // on actual formRules$ observable
    // TODO: get rid of formRules observable in favor of dynamic form changes.
    // This concept is overcomplicated and slow.
    if (!this.formRules$) {
      this.formRules$ = observableOf(this.formRules || {});
    }
  }

  public buildDetailDrawerPopupOpts(
    gridData: DetailDrawerFormData,
    additionOptions?: AdditionBuildOptions,
  ): IPopupOptions {
    const popupOptions: IPopupOptions = {};

    return popupOptions;
  }

  public openDrawer(
    gridData: DetailDrawerFormData,
    additionOptions?: AdditionBuildOptions,
  ): void {
    const defaultPopupOpts: IPopupOptions = {
      validation: false,
      schema: {
        type: 'object',
        properties: {
          items: { type: 'array' },
        },
      },
      value: {
        items: [],
      },
      formRules: {
        fields: {
          items: {
            title: I18n.Forms.GridForm.DetailDrawerFormTitle,
            widget: WIDGET_COMPONENT.edit_grid_custom,
            class: 'hide-header-row without-border',
            widgetData: {
              gridHeight: '100%',
              hideActionPanel: true,
              orderControls: false,
              multiselect: false,
              disableColumnSelector: true,
              userGridOptions: {
                domLayout: 'autoHeight',
              },
            },
          },
        },
      },
      buttons: [
        {
          ...BTN_DONE,
          caption: I18n.Common.Close,
          click: this.closeDrawer.bind(this),
        },
      ],
    };

    // need assign this before detailDrawerPopupOptions
    this.detailDrawerPopupDocument = gridData;

    const userPopupOpts = this.buildDetailDrawerPopupOpts(
      gridData,
      additionOptions,
    );

    this.detailDrawerPopupOptions = merge(defaultPopupOpts, userPopupOpts);

    this.showDetailDrawerPopup = true;
  }

  public closeDrawer(): void {
    this.showDetailDrawerPopup = false;
    this.detailDrawerPopupDocument = null;
  }

  /**
   * get operation history data from document
   *
   * @param document based on document
   * @returns operation history data
   */
  protected getAllOperationHistory(
    document: Partial<IBaseEntityType>,
  ): IOperationHistory[] {
    if (isEmpty(document)) {
      return [];
    }

    const statusHistoryOperations: IOperationHistory[] = orderBy(
      map(
        document[DOCUMENT_PATH.STATUS_HISTORY],
        (status: IStatusHistory) =>
          <IOperationHistory>{
            operated_time: status.updated_at,
            operation: status.to,
            operator_id: status.updated_by,
          },
      ),
      'operated_time',
    );

    const create: IOperationHistory = {
      operated_time: document[DOCUMENT_PATH.CREATE_AT],
      operator_id: document[DOCUMENT_PATH.CREATE_BY],
      operation: COMMON_STATUS.CREATED,
    };

    const update: IOperationHistory = {
      operated_time: document[DOCUMENT_PATH.UPDATE_AT],
      operator_id: document[DOCUMENT_PATH.UPDATE_BY],
      operation: COMMON_STATUS.LAST_UPDATED,
    };

    return [create, ...statusHistoryOperations, update];
  }

  /**
   * add operator name to operation history
   * operator name is from xprt service
   *
   * @param operationHistory target operation history
   * @returns operation history with operator name
   */
  protected addOperationOperatorName(
    operationHistory: IOperationHistory[],
  ): Observable<IOperationHistory[]> {
    if (isEmpty(operationHistory)) {
      return observableOf([]);
    }

    const operatorIds = uniq(
      filter(
        map(operationHistory, (operation) => operation.operator_id),
        Boolean,
      ),
    );

    if (isEmpty(operatorIds)) {
      return observableOf(operationHistory);
    }

    const xprtDataService: XprtDataService =
      this.utilityServiceProvider.getUtilityService(
        XprtDataService.UTILITY_TYPE,
      );

    const staffDataService: StaffDataService =
      this.utilityServiceProvider.getUtilityService(
        StaffDataService.UTILITY_TYPE,
      );

    return xprtDataService
      .getUsersInfoByFilter({
        filter: `_id eq in(${operatorIds.join()})`,
      })
      .pipe(
        rx.map((userInfos: ICompanyUserType[]) => {
          const updatedUserInfos: IOperationHistory[] = map(
            operationHistory,
            (operation) => {
              const matchUser = find(
                userInfos,
                (user) => user.id === operation.operator_id,
              );

              return { ...operation, operator_name: matchUser?.name };
            },
          );

          const undefinedNamesIds = uniq(
            map(
              filter(updatedUserInfos, (user) => !user?.operator_name),
              'operator_id',
            ),
          );

          return [updatedUserInfos, undefinedNamesIds];
        }),
        rx.switchMap(
          ([updatedUserInfos, undefinedNamesIds]: [
            IOperationHistory[],
            string[] | undefined,
          ]) => {
            if (isEmpty(undefinedNamesIds)) {
              return of(updatedUserInfos);
            }

            return staffDataService.batchGetUserInfo(undefinedNamesIds).pipe(
              rx.switchMap((allResults) => {
                const updatedEmployeeNameInfos = map(
                  updatedUserInfos,
                  (userInfo) => {
                    const matchedUser = find(
                      allResults,
                      (user: IStaffUserInfo) =>
                        isEqual(user.EmployeeId, userInfo.operator_id),
                    );

                    return {
                      ...userInfo,
                      operator_name:
                        matchedUser?.Name ?? userInfo?.operator_name,
                    };
                  },
                );

                return of(updatedEmployeeNameInfos);
              }),
            );
          },
        ),
        rx.catchError((_) => of(operationHistory)),
      );
  }

  /**
   * build sidebar details for left sidebar
   *
   * @param document base document
   * @returns sidebar details(will be [{ elements:[{ title: 'xxx', value: 'xxx', subValue: 'xxx' }]} ])
   */
  protected buildDocumentSidebarDetails(
    operationHistory: IOperationHistory[],
  ): Partial<IBaseEntityType> {
    const service = this.entityServiceProvider.getService(this.entityType);
    if (get(service, 'config.auditTrailUrl')) {
      service.operateList = uniqBy(
        map(operationHistory, (operations) => {
          return {
            ...operations,
            checked: true,
          };
        }),
        'operator_id',
      );
    }

    return [{ elements: this.operationSidebarElementMapper(operationHistory) }];
  }

  /**
   * sidebar operation status mapping(status to status text mapping)
   * you can custom your own status mapping here.
   *
   * @returns status mapping
   */
  protected getSidebarOperationStatusMapping(): Record<string, string> {
    return {};
  }

  /**
   * map operations data to side bar item
   * side bar item title will use status mapping to convert,
   * will use startCase(operation) directly when status mapping is empty.
   *
   * @param operations operations data
   * @returns side bar item
   */
  protected operationSidebarElementMapper(
    operations: IOperationHistory[],
  ): ISideBarItem[] {
    if (isEmpty(operations)) {
      return [];
    }

    const statusMapping = this.getSidebarOperationStatusMapping();

    return map(operations, (history) => ({
      // use mapping value replace startCase(history.operation) if operation exist in mapping
      title: has(statusMapping, history.operation)
        ? statusMapping[history.operation]
        : startCase(history.operation),
      value: this.companyUtilsService.convertUTCDateWithTimeZone(
        history.operated_time,
        true,
        TIME_FORMATS.L_LT,
      ),
      subValue: `${isEmpty(history.operator_name) ? I18n.Common.Unknown : history.operator_name}`,
    }));
  }

  protected getSidebarDetailSelectFields(): string[] {
    return [
      DOCUMENT_PATH.CREATE_AT,
      DOCUMENT_PATH.CREATE_BY,
      DOCUMENT_PATH.STATUS_HISTORY,
      DOCUMENT_PATH.UPDATE_AT,
      DOCUMENT_PATH.UPDATE_BY,
    ];
  }

  protected getCurrentDocObs(): Observable<IBaseEntityType> {
    const sidebarDetailsSelectFields = this.getSidebarDetailSelectFields();

    return observableCombineLatest([
      this.stateService.selectCurrentEntity(),
      this.triggerSidebarDetailUpdate$,
    ]).pipe(
      rx.map(([currentStateDoc, updatedDoc]) => {
        const doc = updatedDoc ?? currentStateDoc;

        if (isEmpty(sidebarDetailsSelectFields)) {
          return doc;
        }

        return pick(doc, sidebarDetailsSelectFields);
      }),
    );
  }

  /**
   * set document sidebar info through document basic info with targetFieldPath
   */
  protected setDocumentSidebarDetails(): void {
    // only get document with sidebar field
    const sidebarDetailInfos: Observable<Partial<IBaseEntityType>> =
      this.getCurrentDocObs().pipe(
        rx.filter((document: Partial<IBaseEntityType>) => !isEmpty(document)),
        rx.map(this.getAllOperationHistory.bind(this)),
        rx.switchMap(this.addOperationOperatorName.bind(this)),
        rx.map(this.buildDocumentSidebarDetails.bind(this)),
        rx.filter(
          (sidebarDetails: Partial<IBaseEntityType>) =>
            !isEmpty(sidebarDetails),
        ),
      );

    this.subscriptions.push(
      sidebarDetailInfos.subscribe((sidebarDetails) => {
        this.documentSidebarDetails = sidebarDetails;
      }),
    );
  }

  protected emitWidgetEvent<T extends AnyObject>(
    widgetFieldPath: string,
    eventName: string,
    data: T,
  ): void {
    this._widgetsEventBus$.next({ widgetFieldPath, eventName, data });
  }

  public beforePageLoadPopupFormRulesMapper<T = Object>(
    formRules: IFormRules,
    popupResult: T,
  ): IFormRules {
    return formRules;
  }

  public formRulesMapper(formRules: IFormRules): IFormRules {
    return formRules;
  }

  // show popup with form before page loaded (usually used to set some values before page visit)
  public async showBeforePageLoadPopup(
    schema: SchemaNode,
    document: IBaseEntityType = this.document,
    entityConfig: IEntityConfig = this.entityConfig,
    options?: IBeforePageLoadPopupOptions,
  ): Promise<IModalDialogResult> {
    if (!this.isBeforePageLoadPopupNeeded(entityConfig)) {
      return { confirmed: true, value: null };
    }

    const beforePageLoadPopupConfig =
      entityConfig?.editor?.beforePageLoadPopupConfig;
    const modalDialogOptions =
      beforePageLoadPopupConfig?.modalDialogOptionsMapper
        ? await beforePageLoadPopupConfig.modalDialogOptionsMapper(
            beforePageLoadPopupConfig.modalDialogOptions,
            schema,
            this,
          )
        : beforePageLoadPopupConfig.modalDialogOptions;
    const modalDialogResult =
      await this.uiActions.promptFormModal(modalDialogOptions);

    // wait until popup close before page loader appear
    await new Promise(
      (res): ReturnType<typeof setTimeout> =>
        setTimeout(res, COLLAPSE_ANIMATION_DURATION_MS),
    );

    if (modalDialogResult.confirmed) {
      this.onAfterPageLoadPopupConfirmed(modalDialogResult.value, document);
    } else if (isFunction(options?.onCancel)) {
      options.onCancel();
    } else if (
      !modalDialogResult.confirmed &&
      !isNil(entityConfig.editor.beforePageLoadPopupConfig)
    ) {
      this.uiActions.openRoute(ENTITY_MODULE[this.entityType]);
    } else {
      this.location.back();
    }

    return modalDialogResult;
  }

  // check wether we need to show popup (with form) before page loaded - can be override if needed
  public isBeforePageLoadPopupNeeded(
    entityConfig: IEntityConfig = this.entityConfig,
  ): boolean {
    return (
      this.needBeforePageLoadPopup &&
      // use this to handle will show popup when id is not right
      isEmpty(this._id) &&
      this.mode === EDITOR_MODE.NEW &&
      !!entityConfig?.editor?.beforePageLoadPopupConfig
    );
  }

  // hook that is run with confirmed result of popup (with form) before page loaded - can be override if needed
  public onAfterPageLoadPopupConfirmed(
    modalConfirmedValue: Partial<IBaseEntityType>,
    document: IBaseEntityType,
  ): void {
    // by default we mutate document here (this.document that will be putted in 'new' form)
    merge(document, modalConfirmedValue);
  }

  // save initial document for future use
  // for example changes comparison or form reset to initial value
  public saveInitialDocument(): void {
    this.subscriptions.push(
      this.currentDocument$
        .pipe(rx.filter(Boolean), rx.first())
        .subscribe((doc: IBaseEntityType) => (this.initialDocument = doc)),
    );
  }

  public getModalOptionEntitiesConfig(
    title: string,
    entityType: ENTITY_TYPES,
    entityDescription?: string,
  ): IKeyValueAny {
    const leaveConfirmMsg = {
      title: EDITOR_MESSAGES.customTitle(entityType),
      text: EDITOR_MESSAGES.customConfirmation({
        title,
        entityType,
        entityDescription,
        i18nService: this.i18nService,
      }),
      buttons: [BTN_YES, BTN_CANCEL],
    };
    const modalOption = {
      [EDITOR_MODE.NEW]: leaveConfirmMsg,
      [EDITOR_MODE.EDIT]: leaveConfirmMsg,
    };
    const entityTypes: ENTITY_TYPES[] = [
      ENTITY_TYPES.ORDER,
      ENTITY_TYPES.TRANSFER,
      ENTITY_TYPES.STAND_WORKSHEET,
      ENTITY_TYPES.HAWKER_SESSION,
    ];

    const entitiesConfig = {
      default: {
        [EDITOR_MODE.NEW]: leaveConfirmMsg,
        [EDITOR_MODE.EDIT]: {
          text: EDITOR_MESSAGES.customConfirmation({
            title,
            entityType,
            entityDescription,
            i18nService: this.i18nService,
          }),
        },
      },
    };
    forEach(entityTypes, (entity: ENTITY_TYPES) => {
      set(entitiesConfig, entity, modalOption);
    });

    return entitiesConfig;
  }

  public getModalOptionsByEntity(
    entityType: ENTITY_TYPES,
    mode: EDITOR_MODE,
    title: string,
  ): IModalDialogOptions {
    const entityModalConfig = this.getModalOptionEntitiesConfig(
      title,
      entityType,
    );

    return (
      get(entityModalConfig, `${entityType}.${mode}`) ||
      get(entityModalConfig, `default.${mode}`)
    );
  }

  public async canDeactivate(
    component: IComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): Promise<boolean> {
    const dirty: boolean = get(this.form, 'dirty');
    if (!dirty) {
      return true;
    }

    if (this.isRequestPendingForEditor()) return true;

    const options = this.getModalOptionsByEntity(
      this.entityType,
      this.mode,
      this.title,
    );

    const { confirmed }: IModalDialogResult =
      await this.uiActions.confirm(options);

    if (this.form && confirmed) {
      this.form.markAsPristine();
    }

    return confirmed;
  }

  protected getFieldsToSetDisable(formRules: IFormRules): string[] {
    return [];
  }

  protected getDocumentOpenMode(doc: IBaseEntityType): EDITOR_MODE {
    return get(doc, '_id') ? EDITOR_MODE.EDIT : EDITOR_MODE.NEW;
  }

  protected generateObjectId(): ObjectId {
    return generateObjectId();
  }

  protected requestPendingStatusHandler(selector: string): void {}

  protected async submitBtnClickResultHandler<T = IBaseEntityType>(
    requestResult: T,
    dataToKeepInDocument: FieldsToKeepAfterUpdateType,
    params: IDocumentOperationOptions = {},
    dataToReturn?: T,
  ): Promise<T> {
    this.requestPendingStatusHandler(
      get(dataToKeepInDocument, this.entityIdPath),
    );

    const error = get(requestResult, 'errors', []);
    if (!isEmpty(error)) {
      if (!isTimeoutStatusCode(error)) {
        this.uiActions.removeNotificationsOnPageLeave();
      }
      this.formStateHandlerWhenErrorHappened(
        error,
        get(dataToKeepInDocument, this.entityIdPath),
      );
      if (params.suppressErrors && isFunction(params.customErrorsFn)) {
        params.customErrorsFn(error, this.uiActions);
      }

      return;
    }

    let result = !isUndefined(dataToReturn) ? dataToReturn : requestResult;
    if (this.isExtendDocumentWithEntityIdAfterSave()) {
      if (isEmpty(result)) result = {} as T;
      this.extendDocumentWithOriginData(result, dataToKeepInDocument);
    }

    this.form.markAsPristine();
    this.saveOperationId = generateObjectId();

    return result;
  }

  protected isExtendDocumentWithEntityIdAfterSave(): boolean {
    return true;
  }

  /**
   * get filter out empty field value change
   *
   * @param fieldPath target field path
   * @returns field value change observable
   */
  protected getFieldChangeFilterEmpty(fieldPath: string): Observable<string> {
    return this.fieldValueChanges(fieldPath).pipe(
      rx.filter((value) => !isEmpty(value)),
      rx.distinctUntilChanged(),
    );
  }

  /**
   * get isRequestPending with default data
   * will return default value when isRequestPendingForEditor$ is null
   *
   * @param defaultValue default isRequestPending value.(default is false)
   * @returns isRequestPending
   */
  public isRequestPendingForEditorWithDefault(
    defaultValue: boolean = false,
  ): boolean {
    return !!this.isRequestPendingForEditor$
      ? this.isRequestPendingForEditor()
      : defaultValue;
  }

  public isRequestPendingForEditor(): boolean {
    const path = this.getPendingInformationPath(true);

    return this.stateService.getByPath(path, false);
  }

  public initStoreObservables(): void {
    this.currentDocument$ = this.selectProperty('currentDocument');
    if (!this.schema$) {
      this.schema$ = this.selectProperty('schema').pipe(rx.find(Boolean));
    }
    this.apiErrors$ = this.selectProperty('errors');
  }

  /**
   * Returns an observable of property in entity store.
   * Handles composite entity storage
   *
   * @param propertyName
   */
  public selectProperty(propertyName: string | string[]): Observable<any> {
    const entityPath: string[] = ['entities', this.entityType].concat(
      propertyName,
    );

    return this.stateService.select(entityPath);
  }

  // creates an observable from field path
  // can be used before form is created
  // Starts emitting change events once form is ready
  public fieldValueChanges = (
    path: string,
    fieldValueChangesOptions: IFieldValueChangesOptions = {},
  ): Observable<any> =>
    observableFrom(
      this.formPromise.then((form: AbstractControl) =>
        observableDefer(() => {
          const control = form.get(path);
          if (!control) return observableEMPTY;

          return control.valueChanges.pipe(
            rx.startWith(control.value),
            rx.filter(() => {
              if (
                fieldValueChangesOptions?.doNotTrackWhenFormIsPending &&
                form.pending
              ) {
                return false;
              }
              if (
                fieldValueChangesOptions?.doNotTrackDisabledControl &&
                control.disabled
              ) {
                return false;
              }

              return true;
            }),
          );
        }),
      ),
    ).pipe(rx.switchAll());

  // creates an observable from field path
  // can be used before form is created
  // Starts emitting change events once form is ready
  public fieldStatusChanges = (path: string): Observable<any> =>
    observableFrom(
      this.formPromise.then((form: AbstractControl) =>
        observableDefer(() => {
          const control = form.get(path);
          if (!control) return observableEMPTY;

          return control.statusChanges.pipe(rx.startWith(control.value));
        }),
      ),
    ).pipe(rx.switchAll());

  // helper function to be used in validators e.g. :
  // validators: [minValue(editor.fieldValueGetter('otherField'))]
  public fieldValueGetter =
    (path: string): any =>
    (): any =>
      get(this.form, ['value'].concat(path.split('.')));

  // Schedules validity update for all provided fields once
  // a value of any of these fields is changed
  // e,g, this.linkFieldValidation('minValue', 'maxValue')
  public async linkFieldValidation(...fieldList: string[]): Promise<void> {
    const form: FormGroup = await this.formPromise;

    this.subscriptions.push(
      ValidationService.linkedFieldsValidation(fieldList, form),
    );
  }

  public markAndSetValue(controlPath: string, value: any): void {
    const control = this.getFormFieldControl(controlPath);
    control.setValue(value);
    control.markAsTouched();
    control.markAsDirty();
  }

  public markFieldsAsDirty(fields: string[]): void {
    each(fields, (field) => this.getFormFieldControl(field).markAsDirty());
  }

  public getTitleOnDocumentChange(): string {
    return this.isNewMode()
      ? this.title
      : this.i18nService.instant(I18n.CommonEditor.EditDocTitle, {
          entityName: this.i18nService.instant(
            getSingularEntityName(this.entityType),
          ),
          additionalText: this.getInternalNumberTitle(),
        });
  }

  public getInternalNumberTitle(): string {
    const internalNumber = this.document?.internal_number;

    return internalNumber ? ` - ${internalNumber}` : '';
  }

  public onDocumentChange(
    newDoc: IBaseEntityType,
    editorMode?: EDITOR_MODE,
    patchForm: boolean = true,
  ): void {
    this.mode = editorMode || this.getDocumentOpenMode(newDoc);
    this.entityFormService.updateFormMode(this.mode);
    this.uiActions.setFormMode(this.mode);
    this.title = this.getTitleOnDocumentChange();

    const documentToPatch = removeNullPropertiesFromObject(newDoc || {});
    const patch = {
      ...documentToPatch,
      virtual: {
        // additional information data to include in the document AND in the form's virtual section.
        // e.g. after adding virtual.mode field into formRules the 'virtual.mode' field
        // can be used in 'show', 'disabled' and 'omit' predicates
        mode: this.mode,
        ...get(documentToPatch, 'virtual', {}),
      },
    };
    this.document = this.mapNewDocumentFormPatch(patch);
    if (this.form && patchForm) {
      this.form.patchValue(patch);
    }

    this.isDeletedDocument = !get(this.document, 'is_active', true);
    if (this.isDeletedDocument) {
      this.canManage = false;
      this.checkCanViewDeleted();
    }
  }

  public mapNewDocumentFormPatch(patch: IBaseEntityType): IBaseEntityType {
    return patch;
  }

  public checkCanViewDeleted(): void {
    const permissions = get(this.entityConfig, 'permissions', []);
    const canViewDeleted =
      PermissionService.hasViewDeletedPermission(permissions);
    const canView = PermissionService.hasViewPermission(
      permissions,
      this.entityType,
    );

    if (!canViewDeleted || !canView) {
      this.uiActions.showErrorPage({
        ...NOT_PERMITTED_ERROR_PAGE_TEMPLATE,
        details: this.i18nService.instant(
          I18n.ErrorMessages.MissingFollowingPermissions,
          { permissions: '"deleted-entities.View"' },
        ),
      });
    }
  }

  public unsubscribeAll(): void {
    this.subscriptions.forEach((sub: Subscription) => sub?.unsubscribe());
    this.subscriptions = [];

    if (this.formRulesSubscription) {
      this.formRulesSubscription.unsubscribe();
      this.formRulesSubscription = null;
    }
  }

  public redirectAfterSave(
    entityType: ENTITY_TYPES,
    doc: IBaseEntityType,
    changeRouteExecutor: Function,
  ): void {
    if (this.isInModalDialog && isFunction(this.handelModalAfterSave)) {
      this.handelModalAfterSave();

      return;
    }
    const currentEntityType = this.stateService.getCurrentEntityType();
    if (entityType !== currentEntityType || this.isPageLeft) return;

    let docIdInRoute = this.stateService
      .getByPath('router')
      .split('/')
      .splice(-1)[0];
    docIdInRoute = docIdInRoute.includes('?')
      ? docIdInRoute.split('?')[0]
      : docIdInRoute;
    const currentDocument = this.stateService.getByPath(
      ['entities', entityType, 'currentDocument'],
      {},
    );
    const currentDocumentId = get(currentDocument, '_id');
    const currentDocumentEntityId = get(currentDocument, this.entityIdPath);
    const savedDocumentEntityId = get(doc, this.entityIdPath);
    const isCurrentDocumentHasTheSameEntityIdAsSavedDocument =
      savedDocumentEntityId === currentDocumentEntityId;
    const isCurrentDocumentHasTheSameIdAsSavedDocument =
      currentDocumentId === docIdInRoute;
    const isAddEntityMode = startsWith(docIdInRoute, 'add');

    if (
      ((savedDocumentEntityId &&
        !isCurrentDocumentHasTheSameEntityIdAsSavedDocument) ||
        !isCurrentDocumentHasTheSameIdAsSavedDocument) &&
      !isAddEntityMode
    ) {
      return;
    }

    changeRouteExecutor();
  }

  public async submitBtnClick(
    documentItem: IBaseEntityType = this.document,
    params: IDocumentOperationOptions = {},
  ): Promise<any> {
    const skipValidate = get(params, 'skipValidate', false);
    if (
      !skipValidate &&
      (!this.form.valid || this.isRequestPendingForEditor())
    ) {
      return;
    }
    const { formValueGetter = () => Object.assign({}, this.form.value) } =
      params;

    let result = null;

    const _id = get(documentItem, '_id', null);
    const fieldToKeep: FieldsToKeepAfterUpdateType =
      this.getFieldsToKeep(documentItem);

    // update existing document
    if (this.mode === EDITOR_MODE.EDIT) {
      const formValue = formValueGetter({
        documentItem,
        params,
        form: this.form,
      });

      result = await this.updateDocument(formValue, _id, params);
      // create new document
    } else {
      // We need this line because in huge amount of services "backToFrontItemMapper" was rewritten
      // without calling super.backToFrontItemMapper(item) - as a result we have missing
      // Unfortunately we can't add missing "super.backToFrontItemMapper(item)" now
      // as there is hight chance of broking business logic.
      const newDocument = formValueGetter({
        documentItem,
        params,
        form: this.form,
      });

      result = await this.createDocument(
        newDocument,
        // don't know if the other parameters will have any other effect, but here we just need the suppressErrors parameter
        pick(params, ['suppressErrors']),
      );
    }

    return this.submitBtnClickResultHandler(result, fieldToKeep, params);
  }

  public async saveButtonClickHandler(
    documentItem: IBaseEntityType = this.document,
    customRedirect?: CustomRedirect,
  ): Promise<void> {
    if (!this.form?.dirty) return;
    const saveResult = await this.submitBtnClick(documentItem);
    const savedDoc = Array.isArray(saveResult)
      ? saveResult.shift()
      : saveResult;
    // The document is `undefined` in case of Error, that is, we need to stay on the Add/Edit page
    if (!savedDoc || (!savedDoc._id && this.isNewMode())) return;

    const _id = this.getIdForRedirect(savedDoc);

    const savedDocWithRedirectId = { ...savedDoc, _id };

    this.redirectAfterSave(this.entityType, savedDocWithRedirectId, () => {
      const redirectFunc = isFunction(customRedirect)
        ? customRedirect
        : this.getRedirectExecutor(customRedirect || _id).bind(this);

      redirectFunc(savedDocWithRedirectId);
    });
  }

  public getCreateWithDataRedirect(
    options?: CustomRedirectOptions,
  ): CustomRedirectFun {
    const defaultOptions: CustomRedirectOptions = {
      id: 'add',
      carryFields: this.createWithDataCarryFields,
      forceReload: true,
    };

    const { id, carryFields, ...otherRouteOptions } = merge(
      {},
      defaultOptions,
      options,
    );

    if (isEmpty(carryFields)) {
      return;
    }

    const carryValue = pick(get(this.form, 'value', {}), carryFields);

    const redirectExecutor = this.getRedirectExecutor(id, {
      ...otherRouteOptions,
      state: {
        autoPopulate: carryValue,
      },
    });

    return redirectExecutor;
  }

  public async saveAndNewButtonClickHandler(
    documentItem: IBaseEntityType = this.document,
  ): Promise<void> {
    await this.saveButtonClickHandler(
      documentItem,
      this.getCreateWithDataRedirect().bind(this),
    );
  }

  public async submitAndNewButtonClickHandler(
    documentItem: IBaseEntityType = this.document,
  ): Promise<void> {}

  public getRedirectExecutor(
    id: string,
    options: IOpenRouteOptions = { forceReload: true },
    params?: {},
  ): CustomRedirectFun {
    return (): void => {
      const defaultParams = {
        ...(this.showDuplicateButton && { showDuplicate: true }),
      };

      this.apiActions.openDocumentEditor(this.redirectEntityType, id, options, {
        ...defaultParams,
        ...params,
      });
    };
  }

  public openListPage(): void {
    this.apiActions.openList(this.redirectEntityType);
  }

  public async deleteBtnClick(): Promise<void> {
    const modalOptions = this.getDeleteModalOptions();
    const result = await this.uiActions.confirm(modalOptions);
    if (!result.confirmed) {
      return;
    }
    const docsToDelete = [{ _id: this._id, is_active: false }];

    await this.apiActions.updateEntityAsPromised(this.entityType, docsToDelete);
    this.form.markAsPristine();
    this.openListPage();
  }

  protected getDeleteModalOptions(): IModalDialogOptions {
    const optionsList: IDeleteConfirmationMessageOptionsList = {
      place: ACTION_PLACE.EDIT_FORM,
      access: USER_ACCESS.PARTICULAR,
    };
    const customMessage: string = invoke(
      this.entityConfig,
      'deleteConfirmationMessageFn',
      optionsList,
    );

    return {
      title: I18n.Common.Confirm,
      text:
        customMessage ||
        this.i18nService.translate(
          I18n.InfoMessages.AreYouSureYouWantToRemoveThisEntity,
          {
            entityType: this.i18nService.translate(
              getSingularEntityName(this.entityType),
            ),
          },
        ),
    };
  }

  public async duplicateBtnClick(): Promise<void> {
    if (this.form.dirty) {
      const { confirmed }: IModalDialogResult = await this.uiActions.confirm({
        text: this.i18nService.t(I18n.ConfirmMessages.SaveAndContinue),
      });

      if (!confirmed) {
        return;
      }

      // call duplicate after save success
      await this.saveButtonClickHandler(this.document, () => {
        // update form edit mark
        this.handleVisibilityForEditedMark();

        this.duplicate();
      });

      return;
    }

    await this.duplicate();
  }

  public async duplicate(): Promise<void> {
    const entityService = this.entityServiceProvider.getService(
      this.entityType,
    );

    if (isFunction(entityService.duplicate)) {
      await entityService.duplicate([this.document]);
    }
  }

  public cancelBtnClick(): void {
    // There is no need in complex logic.
    // The canDeactivate guard will handle everything.

    this.openListPage();
  }

  // xux close icon should always lead to the entity list.
  public closeBtnClick(): void {
    this.uiActions.removeNotificationsOnPageLeave();
    this.toolActions.removeAllActionStatuses();
    this.openListPage();
  }

  /**
   * revertToDefaultBtnClick entity-specific logic, should be overwritten in specific entity
   */
  public async revertToDefaultBtnClick(): Promise<void> {}

  public async openAddNewItemForm(): Promise<void> {
    this.apiActions.clearCurrentDocument(this.entityType);
    const uiRoute = this.route.snapshot.data.uiRoute;
    const uri = `${uiRoute}/add`;

    this.uiActions.openRoute(uri, { forceReload: true });
  }

  public isEnterpriseCompany(): boolean {
    return true;
  }

  public createDocument(
    doc: IBaseEntityType,
    options: IDocumentOperationOptions = {},
  ): Promise<any> {
    const operationOptions = { ...options };

    const fieldsToIgnoreNullRemove =
      this.getFieldsToIgnoreNullRemoveWhenCreate(doc);

    const ignoreCheckObjects = reduce(
      fieldsToIgnoreNullRemove,
      (objects, field) => {
        const fieldValue = get(doc, field);
        if (!objects.has(fieldValue)) {
          objects.add(fieldValue);
        }

        return objects;
      },
      new Set([doc]),
    );

    return this.createEntity(
      Object.assign(
        {},
        removeNullPropertiesFromObject(doc, ignoreCheckObjects),
      ),
      Object.assign(
        { endpoint: '', suppressSuccessMessage: true },
        operationOptions,
      ),
    );
  }

  public updateDocument(
    doc: IBaseEntityType,
    id: string,
    options: IDocumentOperationOptions = {},
  ): Promise<any> {
    return this.updateEntity(
      Object.assign({}, doc),
      Object.assign({}, options, {
        endpoint: id,
        suppressSuccessMessage: true,
      }),
    );
  }

  // children mount point for form value changes
  public onFormReady(
    form: FormGroup,
    entityIdPath: string = ENTITY_ID_PATH,
  ): void {
    this.entityIdPath = entityIdPath;
    if (this.isNewMode()) this.newModeHandler();
  }

  /**
   * use this to get an observable that emits when the specified form(s) are ready
   *
   * will return formGroup when there is only one form key specified
   *
   * @param formKeys the form key or array of form keys to wait for readiness
   * @returns an observable that emits the formGroup(s) when the specified form(s) are ready
   */
  public getFormReadyObs(
    formKeys: MainOrSubFormKey,
  ): Observable<MainOrSubFormGroups> {
    return buildFormReadyObsGetter({
      formReady$: this.formReady$,
      form: this.form,
      rightForms: this.rightForms,
    })(formKeys);
  }

  public getForm(formKey: MainOrSubFormKey): FormGroup | null {
    return buildFormGetter({
      form: this.form,
      rightForms: this.rightForms,
    })(formKey);
  }

  public async addResolversErrorHandler(): Promise<void> {
    const results = await Promise.all(this.resolvers);
    const errors = compact(map(results, 'errors'));

    if (isEmpty(errors)) {
      return;
    }

    const permissionMessage: string = chain(errors)
      .map('meta')
      .filter({ code: API_ERROR_CODES.NO_PERMISSIONS_CODE } as object)
      .map('data.permissions')
      .flatten()
      .uniq()
      .sort()
      .join(', ')
      .replace(
        /^\b/,
        this.i18nService.translate(
          I18n.ErrorMessages.YouAreMissingTheFollowingPermissions,
          { permissions: '' },
        ),
      )
      .value();

    if (permissionMessage) {
      this.uiActions.showErrorPage({
        ...ERROR_PAGE_TEMPLATES.NOT_PERMITTED_ERROR_PAGE_TEMPLATE,
        details: permissionMessage,
      });

      return;
    }

    if (find(errors, (error: any): boolean => error instanceof ProgressEvent)) {
      this.uiActions.showErrorPage(
        ERROR_PAGE_TEMPLATES.API_TIMEOUT_ERROR_PAGE_TEMPLATE,
      );

      return;
    }

    if (
      find(map(errors, 'meta'), {
        code: API_ERROR_CODES.NOT_FOUND_BY_ID,
      } as object)
    ) {
      this.uiActions.showErrorPage(
        ERROR_PAGE_TEMPLATES.NOT_FOUND_ERROR_PAGE_TEMPLATE,
      );

      return;
    }

    this.uiActions.showErrorPage(
      ERROR_PAGE_TEMPLATES.GENERIC_ERROR_PAGE_TEMPLATE,
    );
  }

  /**
   * A mount point for form action handlers
   */
  public onFormAction(action: IFormAction): void {
    switch (action.type) {
      case XUX_FORM_ACTIONS.FORM_STATUS_CHANGED:
        this.apiActions.formStatusChanged(this.entityType, action.payload);
        break;
      case XUX_FORM_ACTIONS.FORM_VALUE_CHANGED:
        this.onFormValueChangedApiAction(action);
        break;
      default:
    }
  }

  public onRightFormAction(action: ICommonFormAction): void {
    const { type, payload } = action;
    switch (type) {
      case XUX_FORM_ACTIONS.FORM_READY:
        if (!this.rightForms) {
          this.rightForms = {};
        }

        set(this.rightForms, payload.formKey, payload.form);

        this.formReady$.next({
          ...this.formReady$.value,
          [payload.formKey]: true,
        });
        break;
      case XUX_GRID_ACTIONS.GRID_READY:
        if (!this.rightFormApis) {
          this.rightFormApis = {};
        }

        set(this.rightFormApis, payload.formKey, {
          ...get(this.rightFormApis, payload.formKey, {}),
          gridApi: payload.gridApi,
        });

        break;
      default:
        break;
    }
  }

  public onFormValueChangedApiAction(action): void {
    this.apiActions.formValueChanged(this.entityType, action.payload.value);
  }

  public handleVisibilityForEditedMark(): void {
    if (this.mode !== EDITOR_MODE.EDIT || !this.canManage) {
      this.showItemEditedMark$.next(false);

      return;
    }

    const dirty = get(this.form, 'dirty', false);
    this.showItemEditedMark$.next(dirty);
  }

  public addEditedMarkSubscription(): void {
    this.formPromise.then(() => {
      this.subscriptions.push(
        this.form.valueChanges
          .pipe(rx.debounceTime(0))
          .subscribe(() => this.handleVisibilityForEditedMark()),
      );
    });
    this.subscriptions.push(
      this.routeState$.subscribe((state: IPageJumpRouteState) => {
        if (this.isDuplicateMode) {
          this.needBeforePageLoadPopup = false;

          return;
        }
        this.needBeforePageLoadPopup = isNil(state?.needBeforePageLoadPopup)
          ? true
          : state?.needBeforePageLoadPopup;
      }),
    );
  }

  public inject(token: any, notFoundValue?: any): any {
    return this.injector.get(token, notFoundValue);
  }

  // mount point for group change handlers
  public beforeFormGroupChange = async (
    groupIndex: number,
    selectedGroup: IFormGroupPreferences,
  ): Promise<boolean> => {
    return true;
  };

  public setRequestPendingStatus(status: boolean, entityId: string): void {
    this.uiActions.setPendingRequestStatus({
      status,
      entityType: this.entityType,
      entityIdKey: entityId,
    });
  }

  protected getEntityRequiredFieldsForUpdate(): string[] {
    return [];
  }

  protected mergeFormRules(rawFormRules: IFormRules): IFormRules {
    return merge({}, rawFormRules);
  }

  protected async createEntity(
    input: IBaseEntityType,
    options: IDocumentOperationOptions = {},
  ): Promise<any> {
    if (isEmpty(input)) return {};

    const entityType = get(options, 'entityType', this.entityType);

    return this.apiActions.createEntityAsPromised(entityType, input, {
      ...options,
      mode: this.mode,
      requiredToSendFields: this.getRequiredToSendFields(),
    });
  }

  protected async updateEntity(
    input: IBaseEntityType,
    options: IDocumentOperationOptions = {},
  ): Promise<any> {
    if (isEmpty(input)) return {};

    const documentsForUpdate = await this.onBeforeUpdateEntity();
    const entityType = get(options, 'entityType', this.entityType);

    return this.apiActions.updateEntityAsPromised(
      entityType,
      documentsForUpdate,
      {
        ...options,
        mode: this.mode,
        requiredToSendFields: this.getRequiredToSendFields(),
      },
    );
  }

  protected async onBeforeUpdateEntity(): Promise<IBaseEntityType> {
    const dirtyFields = this.getAllDirtyFields();

    return reduce(
      dirtyFields,
      (doc, field) => {
        return {
          ...doc,
          [field.path]: field.control.value,
        };
      },
      {},
    );
  }

  public isEditMode(): boolean {
    return this.mode === EDITOR_MODE.EDIT;
  }

  public isNewMode(): boolean {
    return this.mode === EDITOR_MODE.NEW;
  }

  protected getIdForRedirect(savedDoc: IBaseEntityType): string {
    return this.mode === EDITOR_MODE.EDIT ? this.document._id : savedDoc._id;
  }

  protected newModeHandler(): void {
    this.addEntityIdToFormAndDocument();
  }

  public initForm(schema: SchemaNode, formRules: IFormRules): void {
    this.form = createFormGroupFromSchema({
      schema,
      rules: formRules,
      fieldsWithoutDefaultValueInEditMode: [],
      mode: this.mode,
      i18nService: this.i18nService,
    });
    this.addLoaderUntilFormLoaded();

    if (this.document) {
      this.form.patchValue(this.document);
    }

    // error subscription
    this.addErrorSubscription(formRules);
    setTimeout(() => {
      this.formReady$.next({ ...this.formReady$.value, main: true });

      this.onFormReady(this.form);
      this.formResolver(this.form);
    }, 0);

    if (this.entityConfig.isFormServiceSupported) {
      this.entityFormService.resolveForm(this.form, {
        rightForms: this.rightForms,
        rightFormApis: this.rightFormApis,
        formReady$: this.formReady$,
      });
    }
  }

  public addErrorSubscription(formRules: IFormRules = {}): void {
    this.subscriptions.push(
      // eslint-disable-next-line import/no-deprecated
      observableMerge(
        this.apiErrors$.pipe(rx.map(ValidationService.apiErrorMapper)),
        this.form.statusChanges.pipe(
          // eslint-disable-next-line import/no-deprecated
          rx.startWith(null),
          rx.debounceTime(0),
          rx.map(() => this.handleFormStatusChanges(formRules)),
        ),
      )
        .pipe(
          // debounce to prevent errorMessage flickering on from reconfiguration
          // much lower value can be used (100ms is fine)
          // but 1 second gives user some time for changes

          // shows error with delay but clears immediately
          rx.debounce((errors: XVIError[]) =>
            observableTimer(errors ? ERROR_MESSAGE_DEBOUNCE : 0),
          ),
        )
        .subscribe((errors: XVIError[]) => {
          this.errors = errors;
          // TODO Should be removed after migration of all editors to using 'XUX' theme
          this.error = head(errors);
        }),
    );
  }

  public handleFormStatusChanges(formRules: IFormRules): XVIError[] {
    return this.form.valid
      ? null
      : ValidationService.getAllFormErrorsRecursively(this.form, formRules, {
          i18nService: this.i18nService,
        });
  }

  public getAllDirtyFields(): IFieldPreferences[] {
    const allFields = flatten(map(this.groups, 'fields'));

    return filter(allFields, 'control.dirty');
  }

  public getDirtyFieldsPath(): string[] {
    return map(this.getAllDirtyFields(), 'path');
  }

  public getFormFieldControl(path: string): AbstractControl {
    if (!this.form) {
      throw Error(
        'getFormFieldControl: property "form" does not exist in editor',
      );
    }

    return this.form.get(path);
  }

  public getFormFieldValue<T>(path: string): T {
    return this.getFormFieldControl(path).value;
  }

  /**
   * provide value for tracking
   */
  public getButtonValue(
    index: number,
    button: ToolbarButtonDefinition,
  ): string {
    // Usually buttons don't have id and value will be used as a unique identifier,
    // however, giving precedence to the "id" property will allow in future
    // to have multiple buttons with the very same value
    return get(button, 'id', get(button, 'value', null));
  }

  /**
   * @deprecated we should re-design this method to handle default export by pdf service v2
   */
  public async exportPdfClickHandler(): Promise<void> {
    if (!this.canExportPDF) {
      return;
    }
    const initPdfResponse = await this.initPdfData();
    if (initPdfResponse) {
      this.pdfBaseService.downloadPdf();
    }
  }

  public exportExcelClickHandler(): void {
    return;
  }

  public exportCsvClickHandler(): void {
    return;
  }

  /**
   * @deprecated we should re-design this method to handle default export by pdf service v2
   */
  public async printPdfClickHandler(
    params: Record<string, string>,
  ): Promise<void> {
    if (!this.canPrint) {
      return;
    }
    const initPdfResponse = await this.initPdfData(params);
    if (initPdfResponse) {
      this.pdfBaseService.printPdf();
    }
  }

  /**
   * @deprecated we should re-design this method to handle default export by pdf service v2
   */
  public printEmptyColumnPdf(): void {
    this.printPdfClickHandler({
      optionPrintParam: TRANSFER_PRINT_TYPE.PRINT_TYPE_EMPTY,
    });
  }

  public disabledPrintOrExportPdf(): boolean {
    return this.isNewMode();
  }

  public disabledPrintEmptyColumnBtn(): boolean {
    return this.isNewMode();
  }

  protected async resolveSchema(): Promise<SchemaNode> {
    return this.schema$.pipe(rx.find(Boolean)).toPromise();
  }

  public isDocumentWithMessage(): boolean {
    return this.entityFormService.isDocumentWithMessage();
  }

  protected childButtonsDisableHandler(): void {
    this.formPromise.then(() => {
      this.subscriptions.push(
        this.form.valueChanges.pipe(rx.debounceTime(0)).subscribe(() => {
          if (isUndefined(this.childButtonsList)) return;
          const childButtonCollection: HTMLCollectionOf<HTMLLIElement> =
            this.childButtonsList.nativeElement.children;
          const enabledChildButtons = Array.from(childButtonCollection).filter(
            (el) => !el.classList.contains('disabled'),
          );
          this.disabledChildButtonDropdown = enabledChildButtons.length === 0;
        }),
      );

      this.form.updateValueAndValidity({ onlySelf: true, emitEvent: true });
    });
  }

  protected async acquireDocument(): Promise<void> {
    let currentDocument = null;
    const { params } = this.routerSnapshot;

    this._id = get(params, 'id', null);

    if (this._id) {
      await this.resolveSchema();
      currentDocument = await this.fetchGetDocumentById();
    }
    if (
      this.isDuplicateMode &&
      !isEmpty(get(this.duplicateOption, 'document'))
    ) {
      currentDocument = get(this.duplicateOption, 'document');

      // TODO is needed?
      this.title = this.i18nService.instant(
        get(this.duplicateOption, 'duplicateTitle'),
      );
    }

    this.onDocumentChange(currentDocument, this.mode);
    this.documentResolver(currentDocument);
    this.entityFormService.resolveDocument(
      currentDocument,
      this.duplicateOption,
    );
  }

  protected getRequiredToSendFields(): string[] {
    const dirtyFields = this.getDirtyFieldsPath();
    const mappedDirtyFields = map(dirtyFields, (field) =>
      this.changedFieldMapper(field),
    );
    const mappedDirtyFieldsHighNested: string[] =
      this.getHighNestedFields(mappedDirtyFields);

    return [
      ...compact(uniq(mappedDirtyFieldsHighNested)),
      ...this.getDefaultRequiredFieldsForUpdate(),
      ...this.getEntityRequiredFieldsForUpdate(),
    ];
  }

  protected getEntityKeyForPendingRequest(): ObjectId {
    return get(
      this.form,
      'value.entity_id',
      get(this, 'document.entity_id', null),
    );
  }

  public changedFieldMapper(field: string): string {
    return get(this.changedFieldsDefinition, field, field);
  }

  protected extendDocumentWithOriginData(
    document: IBaseEntityType,
    dataToKeepInDocument: FieldsToKeepAfterUpdateType,
  ): IBaseEntityType {
    each(castArray(document), (doc) => {
      each(dataToKeepInDocument, (value, key) => {
        if (!has(doc, key)) set(doc, key, value);
      });
    });

    return document;
  }

  protected formStateHandlerWhenErrorHappened(
    error: XVIError,
    entityId: ObjectId,
  ): void {
    return isTimeoutStatusCode(error)
      ? this.form.markAsPristine()
      : this.setRequestPendingStatus(false, entityId);
  }

  protected getFieldsToKeep(
    document: IBaseEntityType,
  ): FieldsToKeepAfterUpdateType {
    const result = {};
    each(
      this.fieldsToKeepInDocumentAfterUpdate,
      (field: FieldsToKeepInDocumentAfterUpdateEnum) => {
        const fieldValue = this.getFieldToKeepValue(document, field);
        if (isUndefined(fieldValue)) return;

        set(result, field, fieldValue);
      },
    );

    return result;
  }

  protected getFieldsToIgnoreNullRemoveWhenCreate(
    document: IBaseEntityType,
  ): string[] {
    return [];
  }

  public getDefaultContainerTitle(): string {
    return (
      this.title ||
      this.i18nService.instant(I18n.CommonEditor.CreateDocTitle, {
        entityName: this.i18nService.instant(
          getSingularEntityName(this.entityType),
        ),
      })
    );
  }

  protected onFormBuildingComplete(): void {
    this.uiActions.formBuildingComplete();
    this.isFormBuilding = false;

    // handle page button change & handle after form build complete
    this.subscriptions.push(this.getPageButtonChangeSubscription());
  }

  public async fetchGetDocumentById(
    documentId: string = this._id,
    options: IDocumentOperationOptions = {},
  ): Promise<IBaseEntityType> {
    const { queryParams } = this.routerSnapshot;

    const getUpdatedItems = get(
      queryParams,
      'get_updated_items',
      this.getUpdatedItemsDefaultValue,
    );

    return this.apiActions.fetchGetDocumentById(this.entityType, documentId, {
      ...options,
      query: {
        ...options.query,
        ...(isNil(getUpdatedItems)
          ? {}
          : { get_updated_items: getUpdatedItems }),
      },
    });
  }

  protected getSaveDisabledDefaultCondition(): boolean {
    return (
      this.isRequestPendingForEditorWithDefault() ||
      !this.form?.valid ||
      !this.form?.dirty ||
      !this.canSave
    );
  }

  protected extendFormRulesWithEntityId(formRules: IFormRules): IFormRules {
    if (has(formRules, `fields.${ENTITY_ID_PATH}`)) return formRules;

    const entityIdObject = {
      omit: false,
    };

    return set(formRules, `fields.${ENTITY_ID_PATH}`, entityIdObject);
  }

  protected doAcknowledge(): Promise<any> {
    if (
      !isNil(this.document._id) &&
      (get(this.document, 'updated_items') ||
        get(this.document, 'unavailable_items'))
    ) {
      const service = this.entityServiceProvider.getService(this.entityType);

      return service.acknowledgeDocument(this.document?._id);
    }
  }

  /**
   * @deprecated we should use pdf service v2 in child class now, need remove this method
   */
  protected async initPdfData(
    params?: Record<string, string>,
  ): Promise<boolean> {
    const currentDocument = this.stateService.getByPath([
      'entities',
      this.entityType,
      'currentDocument',
    ]);
    const service = this.entityServiceProvider.getService(this.entityType);
    let selectedHeaders = null;
    // Exclude Print Written Sheet
    if (service.needSelectedPdfColumns && isEmpty(params)) {
      const headers = service.getPdfHeaders(currentDocument);
      const modalOptions = pdfModalDefinition.selectPdfTableHeadersModal(
        headers,
        of([]),
      );
      const dialogResult = await this.uiActions.promptFormModal(modalOptions);
      const { confirmed, value } = dialogResult;
      if (!confirmed) {
        return false;
      }
      selectedHeaders = reduce(
        headers,
        (arr, header) => {
          if (includes(value.selected_columns, header.text)) {
            arr.push(header);
          }

          return arr;
        },
        [],
      );
    }
    this.uiActions.enableLoader();
    await this.toolActions.fetchInfo();
    const pdfDataStructure = service.transformDocumentToPdfStructure(
      merge({}, currentDocument, params),
      selectedHeaders,
    );
    this.uiActions.disableLoader();
    this.pdfBaseService.generatePdfContent(pdfDataStructure);

    return true;
  }

  public auditTrailBtnClick() {
    this.apiActions.openAuditTrail(this.entityType, this.document._id);
  }

  private getFieldToKeepValue(
    document: IBaseEntityType,
    field: FieldsToKeepInDocumentAfterUpdateEnum,
  ): unknown {
    return (
      document?.[field] ||
      this.fieldToKeepInDocumentAfterUpdateDefaultValue[field]
    );
  }

  private getPendingInformationPath(
    getIsPendingFlag: boolean = false,
  ): string[] {
    const entityIdKey = this.getEntityKeyForPendingRequest();
    const path = [
      'ui',
      'entityItemsRequestCondition',
      this.entityType,
      entityIdKey,
    ];

    if (!getIsPendingFlag) return path;

    return [...path, 'isPending'];
  }

  private addLoaderUntilFormLoaded(): void {
    this.uiActions.formBuildingStarted();
    this.isFormBuilding = true;
    this.subscriptions.push(
      this.form.valueChanges
        .pipe(rx.debounceTime(0), rx.first())
        .subscribe(() => {
          this.onFormBuildingComplete();
        }),
    );
  }

  private setActiveGroup(id: string): void {
    let groupIndex = 0;

    if (!isEmpty(id)) {
      const groups: IFormGroupRules[] = get(this.formRules, 'groups', []);
      groupIndex = Math.max(
        0,
        findIndex(groups, { id }),
        findIndex(groups, ({ name }) => toLower(id) === toLower(name)),
      );
    }
    this.groupIndexControl.setValue(groupIndex);
  }

  private getDefaultRequiredFieldsForUpdate(): string[] {
    return ['_id', this.entityIdPath];
  }

  // activate XUX theme if container switched to new design
  private applyTheme(): void {
    if (this.xuxTheme) {
      this.uiActions.hideNavbar();
      this.uiActions.setUiTheme(XUX_FORM_THEME_CLASS);
    }
  }

  private getHighNestedFields(fields: string[]): string[] {
    return map(fields, (field) => get(split(field, '.'), '[0]', null));
  }

  private setDeleteViewMode(): void {
    this.isDeleteViewMode = this.stateService.isDeleteViewMode();
  }

  private addEntityIdToFormAndDocument(): void {
    const newEntityId = generateObjectId();
    set(this, `document.${this.entityIdPath}`, newEntityId);

    const entityIdControl = this.getFormFieldControl(this.entityIdPath);

    if (!entityIdControl) return;

    entityIdControl.setValue(newEntityId);
  }

  private getRequestPendingStatusForEditor(): Observable<boolean> {
    return observableFrom(this.formPromise).pipe(
      rx.map(() => this.getPendingInformationPath(true)),
      rx.switchMap((path) => this.stateService.select<boolean>(path)),
      rx.map(Boolean),
    );
  }
  // eslint-disable-next-line max-lines
}
